module.exports = __webpack_public_path__ + "media/images/icons/payment_methods/Bancontact-b15fa987ad02bd63afad439e2d5b974d.svg";